(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-map"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('google-map-{{ section.id }}');
  if (!section) return;

  var container = section.querySelector('.google-map-section__iframe-container');
  if (!container) return;

  function sanitizeIframes() {
    var iframes = container.querySelectorAll('iframe');
    iframes.forEach(function (iframe) {
      iframe.removeAttribute('width');
      iframe.removeAttribute('height');

      var s = iframe.getAttribute('style') || '';
      s = s.replace(/width\s*:[^;]+;?/gi, '');
      s = s.replace(/height\s*:[^;]+;?/gi, '');
      iframe.setAttribute('style', s.trim() || 'border:0;');
    });

    var el = container.parentElement;
    var stopsAt = section;
    while (el && el !== stopsAt.parentElement) {
      var computed = window.getComputedStyle(el);
      if (computed.overflow === 'hidden' || computed.overflowX === 'hidden' || computed.overflowY === 'hidden') {
        if (!el.classList.contains('google-map-section__map-wrapper') &&
            !el.classList.contains('google-map-section__iframe-container')) {
          el.style.setProperty('overflow', 'visible', 'important');
        }
      }
      el = el.parentElement;
    }
  }

  sanitizeIframes();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.contains && e.target.contains(section)) {
      sanitizeIframes();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mobile-sticky-bar')) return;

    const MAX_BADGE = 99;

    class MobileStickyBar extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.msb');
        this.cartBadge = this.querySelector('[data-msb-cart-count]');
        this.wishlistBadge = this.querySelector('[data-msb-wishlist-count]');
        this.cartUrl = this.dataset.cartUrl;
        this.wishlistKey = this.dataset.wishlistKey;

        this.onWishlistChange = () => this.syncWishlist();
        this.onStorage = (event) => {
          if (event.key === null || event.key === this.wishlistKey) this.syncWishlist();
        };
        this.onPageShow = (event) => {
          this.syncWishlist();
          if (event.persisted) this.queueCartRefresh();
        };

        if (this.wishlistBadge) {
          this.syncWishlist();
          document.addEventListener('wishlist:updated', this.onWishlistChange);
          window.addEventListener('storage', this.onStorage);
        }
        window.addEventListener('pageshow', this.onPageShow);

        if (this.cartBadge) this.subscribeToCart();
        this.observeHeight();
      }

      disconnectedCallback() {
        document.removeEventListener('wishlist:updated', this.onWishlistChange);
        window.removeEventListener('storage', this.onStorage);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.onLoad) window.removeEventListener('load', this.onLoad);
        if (this.unsubscribe) this.unsubscribe();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.abortController) this.abortController.abort();
        clearTimeout(this.cartTimer);
        document.documentElement.style.removeProperty('--msb-height');
      }

      renderBadge(badge, count) {
        if (!badge) return;
        const text = count > MAX_BADGE ? `${MAX_BADGE}+` : String(count);
        if (badge.textContent !== text) badge.textContent = text;
        badge.setAttribute('data-ready', '');
      }

      getWishlistCount() {
        try {
          const list = JSON.parse(localStorage.getItem(this.wishlistKey));
          return Array.isArray(list) ? list.length : 0;
        } catch (error) {
          return 0;
        }
      }

      syncWishlist() {
        this.renderBadge(this.wishlistBadge, this.getWishlistCount());
      }

      subscribeToCart() {
        const attach = () => {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const count = event && event.cartData && event.cartData.item_count;
            if (typeof count === 'number') this.renderBadge(this.cartBadge, count);
            else this.queueCartRefresh();
          });
          return true;
        };

        if (!attach()) {
          this.onLoad = attach;
          window.addEventListener('load', this.onLoad, { once: true });
        }
      }

      queueCartRefresh() {
        if (!this.cartBadge) return;
        clearTimeout(this.cartTimer);
        this.cartTimer = setTimeout(() => this.refreshCart(), 80);
      }

      async refreshCart() {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        try {
          const response = await fetch(this.cartUrl, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
            signal: this.abortController.signal,
          });
          if (!response.ok) return;
          const cart = await response.json();
          this.renderBadge(this.cartBadge, cart.item_count);
        } catch (error) {
        }
      }

      observeHeight() {
        if (!this.nav) return;
        const update = () => {
          document.documentElement.style.setProperty('--msb-height', `${this.nav.offsetHeight}px`);
        };
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(this.nav);
        } else {
          update();
        }
      }
    }

    customElements.define('mobile-sticky-bar', MobileStickyBar);
  })();

  } catch(e) { console.error(e); }
})();
})();
